import React, { useEffect, useState, useCallback} from "react";
import Sidebar from "../../../layout/Sidebar";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import AdminDataTable from "../../../components/common/AdminDataTable";
import { casteColumns } from "../../../tables/casteColumns";
import { can } from "../../../utils/can";

export default function Cast() {
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const PAGE_SIZE = 10;
  const [success, setSuccess] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(PAGE_SIZE); // default 10
  

  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  // Religion list state
  const [religions, setReligions] = useState([]);
  const [editId, setEditId] = useState(null);
  const token = localStorage.getItem("adminToken");
  // cast list
  const [casts, setCast] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [activeSearch, setActiveSearch] = useState("");

  

  const API_URL = process.env.REACT_APP_BASE_URL_API || ""; // make sure no trailing slash

  const fetchReligion = useCallback(async () => {
  try {
    const url = `${API_URL.replace(/\/$/, "")}/api/front/religion`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const result = await response.json();
    if (response.ok) setReligions(result.data);
  } catch (err) {
    console.error("Error fetching religions:", err);
    setReligions([]);
  }
}, [API_URL, token]);


  
   const fetchCaste = useCallback(
    async (pageNumber = 1, pSize = null, currentSearch = activeSearch) => {
      const usedLimit = pSize || pageSize || PAGE_SIZE;
      setListLoading(true);
      try {
        let url = `${API_URL.replace(/\/$/, "")}/api/admin/caste` +
          `?page=${pageNumber}&limit=${usedLimit}` +
          `&sortBy=${sortBy}&sortOrder=${sortOrder}`;

        if (currentSearch && currentSearch.trim()) {
          url += `&search=${encodeURIComponent(currentSearch.trim())}`;
        }
       
        const response = await fetch(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await response.json();
        if (response.ok) {
          setCast(result.data || []);
          setTotalPages(result.totalPages || 1);
        }
      } catch (err) {
        console.error("Error fetching casts:", err);
      } finally {
        setListLoading(false);
      }
    },
    [API_URL, token, PAGE_SIZE, pageSize, sortBy, sortOrder, activeSearch]
  );


  useEffect(() => {
    fetchReligion();
    fetchCaste(page, pageSize, activeSearch);
  }, [page, pageSize, fetchReligion, fetchCaste, sortBy, sortOrder, activeSearch]);

  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();
    setActiveSearch(searchInput);
    setPage(1);
    fetchCaste(1, pageSize, searchInput);
  };

  const handleSearchReset = () => {
    setSearchInput("");
    setActiveSearch("");
    setPage(1);
    fetchCaste(1, pageSize, "");
  };

  // form submit
  const onSubmit = async (data) => {

    if(can("caste","create") === false){
            alert("You don't have permission.");
            return;
        }

    setSuccess("");
    setErrorMsg("");
    setLoading(true);


    try {
      const url = editId
        ? `${API_URL.replace(/\/$/, "")}/api/admin/caste/update/${editId}`
        : `${API_URL.replace(/\/$/, "")}/api/admin/caste/create`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          religion_id: data.religion_id,
          name: data.name.trim(),
          status: data.isActive ? 'Active' : 'Deactive',
          homePage: !!data.homePage,
        }),
      });

      const result = await response.json();

        if (response.ok) {
        setSuccess(editId ? "Caste updated successfully!" : "Caste added successfully!");
        setErrorMsg("");
        reset(); // clear form
        setEditId(null);
        fetchCaste(page, pageSize, activeSearch);
      } else {
        setErrorMsg(result.message || "Failed to save caste.");
        setSuccess("");
      }
    } catch (err) {
      console.error("Error:", err);
      setErrorMsg("Something went wrong. Please try again.");
      setSuccess("");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (caste) => {
    if(can("caste","edit") === false){
            alert("You don't have permission.");
            return;
        }

    setValue("religion_id", caste.religion_id._id);
    setValue("name", caste.name);
    setValue("isActive", caste.status === "Active");
    setValue("homePage", !!caste.homePage);
    setEditId(caste._id); // store id for update
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleHomePageToggle = async (caste) => {
    if (can("caste", "edit") === false) {
      alert("You don't have permission.");
      return;
    }

    try {
      const response = await fetch(
        `${API_URL.replace(/\/$/, "")}/api/admin/caste/update/${caste._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            homePage: !caste.homePage,
          }),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setCast((prev) =>
          prev.map((item) =>
            item._id === caste._id
              ? { ...item, homePage: !caste.homePage }
              : item
          )
        );
      } else {
        setSuccess(result.message || "Failed to update Home Page.");
      }
    } catch (err) {
      console.error(err);
      setSuccess("Something went wrong!");
    }
  };


  // Delete religion
  const handleDelete = async (id) => {
    if(can("caste","delete") === false){
            alert("You don't have permission.");
            return;
        }

    if (!window.confirm("Are you sure you want to delete this caste?")) return;
    try {
      const response = await fetch(`${API_URL.replace(/\/$/, "")}/api/admin/caste/delete/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const result = await response.json();
      if (response.ok) {
        setSuccess("Caste deleted successfully!");
        fetchCaste(page, pageSize);
      } else {
        setSuccess(result.message || "Failed to delete caste.");
      }
    } catch (err) {
      console.error(err);
      setSuccess("Something went wrong!");
    }
  };

  const columns = casteColumns(handleEdit, handleDelete, handleHomePageToggle, PAGE_SIZE);

  const handleSort = (column) => {
  if (!column) return;

  if (sortBy === column) {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  } else {
    setSortBy(column);
    setSortOrder("asc");
  }
};

  return (
    <div class="container body">
      <div class="main_container">
        <Sidebar />
        <Header pageTitle="Caste" />
        {/* page */}
        <div className="right_col" role="main">
          {/* top tiles */}
        
          {/* /top tiles */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Caste Entry</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>

              </ul>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              <div className="row">
                <div className="col-sm-12">
                  {/* filter start */}
                  <div className="filtercont">
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="row">
                        <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                          <label>Select Religion</label>
                          <select className={`form-select ${errors.religion_id ? "is-invalid" : ""}`}
                            {...register("religion_id", { required: "Please select a religion" })}>
                            <option value="">Select</option>
                            {religions.length > 0 &&
                              religions.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))}

                          </select>
                          {errors.religion_id && (
                            <div className="text-danger mt-1">{errors.religion_id.message}</div>
                          )}
                        </div>
                        <div className="col-12" />
                        <div className="col-12 col-sm-4 pr-lg-0 mb-3">
                          <label>Enter Caste</label>
                          <input
                            type="text"
                            className={`form-control ${errors.name ? "is-invalid" : ""}`}
                            {...register("name", {
                              required: "Please enter cast name",
                              minLength: { value: 2, message: "Minimum 2 characters" },
                            })}
                          />
                          {errors.name && (
                            <div className="text-danger mt-1">{errors.name.message}</div>
                          )}
                        </div>
                        <div className="col-12" />
                        <div className="col-12 col-sm-4 pr-lg-0">
                          <input type="checkbox" id="active" {...register("isActive")} />
                          <label htmlFor="active" className="form-label m-2">
                            Active/Deactive
                          </label>
                        </div>
                        {/* <div className="col-12 col-sm-4 pr-lg-0">
                          <input type="checkbox" id="homePage" {...register("homePage")} />
                          <label htmlFor="homePage" className="form-label m-2">
                            Home Page
                          </label>
                        </div> */}
                        <div className="col-12" />
                        <div className="col-12 col-sm-4 pr-lg-0 text-right">
                          <button type="submit" className="btn sitebtn" disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                          {success && <div className="text-success mt-2">{success}</div>}
                          {errorMsg && <div className="text-danger mt-2">{errorMsg}</div>}
                        </div>
                      </div>
                    </form>
                  </div>
                  {/* filter end */}
                </div>
              </div>
            </div>
          </div>
          {/* bod card end */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>Caste List</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>

              </ul>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              {/* Search Bar */}
              <div className="row mb-3">
                <div className="col-12 col-md-6 col-lg-4">
                  <form onSubmit={handleSearchSubmit}>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search caste..."
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                      />
                      <button className="btn sitebtn mb-0" type="submit" style={{ borderRadius: "0 4px 4px 0" }}>
                        <i className="fa fa-search" /> Search
                      </button>
                      {(activeSearch || searchInput) && (
                        <button
                          className="btn btn-secondary mb-0 ms-1 ml-1"
                          type="button"
                          onClick={handleSearchReset}
                        >
                          Reset
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <AdminDataTable
                    columns={columns}
                    data={casts}
                    page={page}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    loading={listLoading}
                    onPageChange={setPage}
                    onPageSizeChange={(size) => {
                      setPageSize(size);  
                      setPage(1);         
                      fetchCaste(1, size); 
                    }}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    onSort={handleSort}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* bod card end */}
        </div>

        {/* page end */}
        <Footer />

      </div>
    </div>
  );
}